import { Range } from "@tiptap/core"
import { Segment } from "../../config/types"

// Source: https://github.com/Clemens-E/obsidian-languagetool-plugin/blob/47dc0d35e1/src/LanguageToolTypings.ts
export type LanguageToolConfigParams = {
  server: string
  apiOptions?: Partial<LanguageToolApiParams>
}

export type RulesConfig = {
  enabledRules: string[]
  disabledRules: string[]
  enabledCategories: string[]
  disabledCategories: string[]
}

export interface LanguageToolApi {
  software: Software;
  warnings: Warnings;
  language: Language;
  matches?: MatchesEntity[] | null;
}
export interface Software {
  name: string;
  version: string;
  buildDate: string;
  apiVersion: number;
  premium: boolean;
  premiumHint: string;
  status: string;
}
export interface Warnings {
  incompleteResults: boolean;
}
export interface Language {
  name: string;
  code: string;
  detectedLanguage: DetectedLanguage;
}
export interface DetectedLanguage {
  name: string;
  code: string;
  confidence: number;
}
export interface MatchesEntity extends Segment {
  segmentType: "SpellCheck";
  message: string;
  shortMessage: string;
  replacements?: ReplacementsEntity[] | null;
  context: Context;
  sentence: string;
  type: Type;
  rule: Rule;
  ignoreForIncompleteSentence: boolean;
  contextForSureMatch: number;
}
export interface ReplacementsEntity {
  value: string;
}
export interface Context {
  text: string;
  offset: number;
  length: number;
}
export interface Type {
  typeName: string;
}
export interface Rule {
  urls?: MoreInfoLink[];
  id: string;
  description: string;
  issueType: string;
  category: Category;
}

export interface MoreInfoLink {
  value: string
}

export interface Category {
  id: string;
  name: string;
}

export type LanguageToolApiParams = {
  text: string;
  data: string;
  username: string;
  apiKey: string;
  dicts: string;
  motherTongue: string;
  preferredVariants: string;
  enabledOnly: string;
  level: "picky" | "default";
  [key: string]: string;
};

export type MatchLocation = {
  offset: number;
  length: number;
}

export class EditorMatch {

  constructor(public id :string = '', public segment?: Segment, public range?: Range) {

  }

  public isValid() {
    return !!this.segment && !!this.range
  }

  public clear() {
    this.segment = undefined
    this.range = undefined
    this.id = ''
  }

  public update(segment: Segment, id :string, range: Range) {
    this.segment = segment
    this.id = id
    this.range = range
  }
}